/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckRequirements/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Requirements from './Requirements/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function CheckRequirements({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/CheckRequirements"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="CheckRequirements.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="xmedium"
 weight="semibold"
 marginBottom={dtSpaceM}
 marginTop={dtSpaceM}
 marginLeft={0}
 text="The following tasks are required before unseating the patient"
/>
<Requirements
  viewPath={`${viewPath}/Requirements`}
/>
</div>
{children}
</React.Fragment>)
}